export const LEGAL_EFFECTIVE = '1 January 2026'
export const LEGAL_EMAIL = 'contact@passwork.ae'
export const PRIVACY_EMAIL = 'privacy@passwork.ae'
